import { render, staticRenderFns } from "./DataFormInputTypeahead.vue?vue&type=template&id=f641123a"
import script from "./DataFormInputTypeahead.vue?vue&type=script&lang=js"
export * from "./DataFormInputTypeahead.vue?vue&type=script&lang=js"
import style0 from "./DataFormInputTypeahead.vue?vue&type=style&index=0&id=f641123a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports